import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiHttp, SCHEMA_VERSION } from '@core/api/api-http';
import { Applicant } from '@features/opportunities/modules/applicant/services/applicant';
import { Trust } from '../models/trust';
import { Beneficiary } from '../models/trust/beneficiary';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class TrustService {
  constructor(private http: ApiHttp) {}

  getSummary(trustId: string): Observable<Trust.Summary> {
    return this.http
      .getEntity<Trust.SchemaContract>(
        environment.clientsApiUrl,
        `trusts/${trustId}`,
        SCHEMA_VERSION.TRUST,
        ApiHttp.getStandardOptions()
      )
      .pipe(
        map((x) => {
          return {
            id: trustId,
            name: x.name,
            applicantType:
              x.trustType === 'SMSF trust'
                ? Applicant.Type.SmsfTrust
                : x.trustType === 'Property / bare trust'
                ? Applicant.Type.BareTrust
                : Applicant.Type.Trust,
            trustType: x.trustType
          };
        })
      );
  }

  deleteTrust(trustId: string): Observable<object> {
    return this.http.deleteEntity(
      environment.clientsApiUrl,
      `trusts/${trustId}`,
      SCHEMA_VERSION.TRUST
    );
  }

  getTrustDefinition(): Observable<Trust.SchemaPropertyDefinition> {
    return this.http.getEntity(
      environment.clientsApiUrl,
      'trusts/schema',
      SCHEMA_VERSION.TRUST,
      ApiHttp.getStandardOptions()
    );
  }

  getBeneficiaryDefinition(): Observable<Beneficiary.SchemaPropertyDefinition> {
    return this.http.getEntity(
      environment.clientsApiUrl,
      'trusts/schema/beneficiaries',
      SCHEMA_VERSION.TRUST,
      ApiHttp.getStandardOptions()
    );
  }

  getTrustForDisplay(id: string): Observable<Trust.Model> {
    return this.http
      .getEntity<Trust.SchemaContract>(
        environment.clientsApiUrl,
        `trusts/${id}`,
        SCHEMA_VERSION.TRUST,
        ApiHttp.getStandardOptions()
      )
      .pipe(map((payload) => Trust.toModel(id, payload)));
  }

  getTrusts() {
    return this.http.getEntity(
      environment.clientsApiUrl,
      'trusts',
      SCHEMA_VERSION.TRUST,
      ApiHttp.getStandardOptions()
    );
  }

  updateTrust(trustId: string, change: Partial<Trust.Model>): Observable<any> {
    return this.http.put(
      environment.clientsApiUrl,
      `trusts/${trustId}`,
      Trust.toSchemaContract(change),
      SCHEMA_VERSION.TRUST,
      ApiHttp.getStandardOptions()
    );
  }
}
